import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import SimpleResponse from 'shared/api/model/SimpleResponse';
import createHttpRequest from 'shared/api/http';

import ConfirmEmailData from '../ConfirmEmailData';

export const confirmEmail = createAsyncThunk<SimpleResponse, ConfirmEmailData>(
    'auth/confirmEmail',
    async({userId, token}) => {
        const response = await createHttpRequest({
            method: 'GET',
            path: ApiUrls.EMAIL_CONFIRM(userId, token),
            errorMessage: t`Ошибка при подтверждении Email`,
            silent: true,
            isAnonymous: true,
        });

        return response.data;
    },
);
